module.exports = __webpack_public_path__ + "h5/img/noNews.778474de.png";